import { useEffect, useState } from "react";

// Below Tailwind's `sm` breakpoint (640px) the Stage controls collapse from the
// persistent bottom rail into a slide-out sheet, so the chrome never covers the
// cushion on a phone (#163, PRD #157 story 17) — DESIGN.md's mobile-first "nav
// collapses to a sheet rather than cramming a desktop bar".
const MOBILE_QUERY = "(max-width: 639px)";

function matchesMobile(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia(MOBILE_QUERY).matches;
}

// Tracks whether the viewport is phone-width. Mirrors usePrefersReducedMotion:
// SSR/headless-safe (matchMedia may be absent), and it seeds from matchMedia on
// the first render via a lazy initializer so there's no desktop-rail flash before
// the effect runs on a real phone. In jsdom the matchMedia stub reports
// `matches: false`, so tests default to the desktop rail unless they stub it.
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(matchesMobile);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const media = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setIsMobile(media.matches);
    onChange();
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
